"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// TODO: Provide a full type for payload below
const getPartner = (payload) => {
    const { PARTNER, // deprecated
    PARTNER_CAR, PARTNER_DELIVERY, PARTNER_EDUCATION, PARTNER_FREELANCE, PARTNER_OTHER, PARTNER_RESTAURANT, PARTNER_SMALL_JOBS, PARTNER_VTC, } = payload;
    return (PARTNER ||
        PARTNER_DELIVERY ||
        PARTNER_VTC ||
        PARTNER_RESTAURANT ||
        PARTNER_FREELANCE ||
        PARTNER_CAR ||
        PARTNER_EDUCATION ||
        PARTNER_OTHER ||
        PARTNER_SMALL_JOBS);
};
exports.default = getPartner;
